import { SAVE_ALL_TORI, GET_NET_RELATION,TORI_SEARCH } from "Stores/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  toriData: [],
  dataRelationTori: [],
  toriDataPagination: { Limit: 10, Page: 1, Total: 0 },
  toriDataSearch: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_ALL_TORI:
      return updateObject(state, {
         toriData: action.toriData,
         toriDataPagination: action.toriDataPagination,
        });
    case TORI_SEARCH:
      return updateObject(state, {
        toriDataSearch: action.toriDataSearch,
      });
    case GET_NET_RELATION:
      return updateObject(state, { dataRelationTori: action.dataRelationTori });
    default:
      return state;
  }
};

export default reducer;
